export default class horizontalTab {

    static init() {

        $("[data-link='collaborative-room']").on("click", function() {
            $(this).addClass('active');
			$('[data-link="phone-booth"]').removeClass('active');
			$('[data-tab="collaborative-room"]').addClass('open');
			$('[data-tab="phone-booth"]').removeClass('open');
        });

		$("[data-link='phone-booth']").on("click", function() {
            $(this).addClass('active');
			$('[data-link="collaborative-room"]').removeClass('active');
			$('[data-tab="collaborative-room"]').removeClass('open');
			$('[data-tab="phone-booth"]').addClass('open');
        });

    }

}
